// heights of header, footer and low credits notification
export const headerHeight = 91;
export const footerHeight = 100;
export const smallFooterHeight = 60;
export const lowWarningHeight = 57;
